import React, { useState, useEffect, useCallback, useMemo } from "react";
import styled from "styled-components";
import Tree from "./tree/Tree";
import TreeAPI from "../../apis/TreeAPI";
import Button from "../Button";
import { database } from "../../firebase";
import clean from "clean-deep";
import StampMessage from "../../components/StampMessage";
import Modal from "../../components/Modal";
import { ReactComponent as ArrowBack } from "../../assets/svg/arrow-back.svg";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import LessonData from "../LessonData";
import { useCourses } from "../../hooks/useCourses";
import { useEpisodes } from "../../hooks/useEpisodes";
import produce from "immer";
import Courses from "../Courses";
import LessonMiddleware from "./edit/LessonMiddleware";
import LessonPreviewMiddleware from "./LessonPreviewMiddleware";
import CourseEdit from "./CourseEdit";
import ListCheckoutPages from "../molecules/ListCheckoutPages";

const Structure = () => {
  const { courses } = useCourses();
  const [courseId, setCourseId] = useState(undefined);
  const course = courses?.find((course) => course.id === courseId);

  const [episode, setEpisode] = useState(undefined);
  const [chapter, setChapter] = useState(undefined);
  const [lesson, setLesson] = useState(undefined);

  const [openCheckout, setOpenCheckout] = useState(false);

  const [showState, setShowState] = useState(undefined);

  const [episodesFull, setEpisodes] = useState(undefined);

  const episodes = useMemo(() => {
    if (!courseId || !episodesFull) return {};

    const course = courses.find((course) => course.id === courseId);

    if (course === undefined || !course?.episodes) return {};
    else
      return produce(episodesFull, (draft) => {
        let result = {};
        course.episodes.forEach((episodeId) => {
          result[episodeId] = draft[episodeId];
        });

        return result;
      });
  }, [episodesFull, courseId, courses]);

  const [chapters, setChapters] = useState(undefined);
  const [lessons, setLessons] = useState(undefined);
  const [details, setDetails] = useState(undefined);

  const [loading, setLoading] = useState(false);

  const [showModalLesson, setShowModalLesson] = useState(false);

  const [state, setState] = useState(undefined);

  console.log({
    courseId,
    episodeId: episode?.id,
    chapter: chapter?.id,
    lesson: lesson?.id,
  });

  const type =
    (lesson?.id && "LESSON") ||
    (chapter?.id && "LESSONS") ||
    (episode?.id && "CHAPTERS") ||
    (courseId && "EPISODES") ||
    "COURSES";

  useEffect(() => {
    const unsubscribe = TreeAPI.subscribeToEpisodes(
      (episode) =>
        setEpisodes((state) => ({
          ...state,
          [episode.id]: { ...episode, published: true },
        })),
      (key) => setEpisodes((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!episode?.id) return;
    setState(undefined);
    setChapters(undefined);
    const unsubscribe = TreeAPI.subscribeToChapters(
      episode?.id,
      (chapter) =>
        setChapters((state) => ({
          ...state,
          [chapter.id]: { ...chapter, published: true },
        })),
      (key) => setChapters((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [episode]);

  useEffect(() => {
    if (!chapter?.id) return;
    setState(undefined);
    setLessons(undefined);
    const unsubscribe = TreeAPI.subscribeToLessons(
      chapter.id,
      (lesson) =>
        setLessons((state) => ({
          ...state,
          [lesson.id]: { ...lesson, published: true },
        })),
      (key) => setLessons((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [chapter?.id]);

  useEffect(() => {
    if (!lesson?.id) return;
    setDetails(undefined);
    const unsubscribe = TreeAPI.subscribeToLessonDetails(
      lesson?.id,
      (key, value) => setDetails((state) => ({ ...state, [key]: value })),
      (key) => setDetails((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [lesson?.id]);

  const onPublish = () => {
    setLoading(true);

    // let update = {};

    // update[`courses/5312c932-494b-4d0e-88f6-f418643e03ad`] = {
    //   title: "Curso 1",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F312a4abb-a610-414c-af16-b61c6c31857b.jpg?alt=media&token=17157e13-3293-4b48-86b7-a51a1ad84eb3",
    //   order: 0,
    //   episodes: {
    //     "93b885adfe0da089cdf634904fd59f71": true,
    //     "1774360a6bb6ceeff99b0a2e7864b2d1": true,
    //     "3485174357449b4f1fe23f9f521483b2": true,
    //   },
    // };

    // update[`courses/ddba5525-6252-4ece-90e1-6b23074736ad`] = {
    //   title: "Curso 2",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2F76a9097d-37e8-4766-bfe4-f8e14caf677c.jpg?alt=media&token=d96ee9f5-d309-4b00-8301-07086cdce902",
    //   order: 1,
    //   episodes: {
    //     "e7913e95-c510-4a89-8b31-a0698f2fe122": true,
    //     "7b8f3b6b-4aab-4bd4-9ae2-62d59b3a86d8": true,
    //     "a42312ea-b7ac-4beb-b294-44843372b702": true,
    //     "337b24b9-1726-41ac-8fe2-88e9d04f4eb8": true,
    //     "da567e84-17e9-45b4-9cee-91fd2aeb24da": true,
    //     "0ebe3f8b-f982-4b88-9d7b-4957404c09ad": true,
    //     "dc519550-408e-4b0b-939e-4d0899640b50": true,
    //     "40c91706-844e-4b89-9df3-8000dd821b44": true,
    //   },
    // };

    // update[`courses/357c6517-7746-449d-a3a9-42b75158af5a`] = {
    //   title: "Curso 3",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/awesome-radi-languages.appspot.com/o/images%2Fab91a0a7-2b0c-4a2b-ba58-d85d4ab1332f.jpg?alt=media&token=30016289-eaca-40eb-b59a-da9e107e543d",
    //   order: 2,
    //   episodes: {
    //     ab6451b4fe7c789a15d876681d09c751: true,
    //     "8f3cb4689f18ae17d88869243f277690": true,
    //     "4d27bb9b-1b9d-4d63-a3e7-6d87a35d2c64": true,
    //   },
    // };

    // database
    //   .ref()
    //   .update(update)
    //   .finally(() => {
    //     setLoading(false);
    //   });

    // return;
    if (type === "EPISODES") {
      let update = {};
      Object.keys(state?.data || {}).forEach((key) => {
        if (
          state?.data[key] &&
          !state?.data[key]?.deleted &&
          state?.data[key]?.id &&
          state?.data[key]?.title &&
          state?.data[key]?.order >= 0
        ) {
          update[`episodes/${state?.data[key].id}`] = {
            title: state?.data[key]?.title,
            order: state?.data[key]?.order,
          };
          update[`courses/${courseId}/episodes/${state?.data[key].id}`] = true;
        } else if (state?.data[key] && state?.data[key]?.deleted) {
          update[`episodes/${state?.data[key].id}`] = null;
          update[`courses/${courseId}/episodes/${state?.data[key].id}`] = null;
        }
      });

      database
        .ref()
        .update(update)
        .then(() => {
          setShowState("SUCCESS");
        })
        .catch(() => {
          setShowState("FAILURE");
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (type === "CHAPTERS") {
      let update = {};
      Object.keys(state?.data || {}).forEach((key) => {
        if (
          state?.data[key] &&
          !state?.data[key]?.deleted &&
          state?.data[key]?.id &&
          state?.data[key]?.title &&
          state?.data[key]?.order >= 0
        )
          update[`chapters/${episode?.id}/${state?.data[key].id}`] = {
            title: state?.data[key]?.title,
            order: state?.data[key]?.order,
          };
        else if (state?.data[key] && state?.data[key]?.deleted)
          update[`chapters/${episode?.id}/${state?.data[key].id}`] = null;
      });

      database
        .ref()
        .update(update)
        .then(() => {
          setShowState("SUCCESS");
        })
        .catch(() => {
          setShowState("FAILURE");
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (type === "LESSONS") {
      let update = {};
      Object.keys(state?.data || {}).forEach((key) => {
        if (
          state?.data[key] &&
          !state?.data[key]?.deleted &&
          state?.data[key]?.id &&
          state?.data[key]?.title &&
          state?.data[key]?.order >= 0
        )
          update[`lessons/${chapter?.id}/${state?.data[key].id}`] = {
            title: state?.data[key]?.title,
            order: state?.data[key]?.order,
          };
        else if (state?.data[key] && state?.data[key]?.deleted)
          update[`lessons/${chapter?.id}/${state?.data[key].id}`] = null;
      });

      database
        .ref()
        .update(update)
        .then(() => {
          setShowState("SUCCESS");
        })
        .catch(() => {
          setShowState("FAILURE");
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (type === "LESSON") {
      let update = {};
      const dataType = getType(details?.data);

      update[`lessons_details/${lesson?.id}`] = clean(state);

      database
        .ref()
        .update(update)
        .then(() => {
          setShowState("SUCCESS_LESSON");
        })
        .catch(() => {
          setShowState("FAILURE");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const ModalState = (
    <ModalStyled>
      <ContainerState>
        {showState === "SUCCESS" && (
          <StampMessage success text="Lista actualizada!" />
        )}
        {showState === "SUCCESS_LESSON" && (
          <StampMessage success text="Lección actualizada!" />
        )}
        {showState === "FAILURE" && (
          <StampMessage wrong text="Ocurrió un error. " />
        )}
        <ButtonState
          text="OK"
          primary
          loading={loading}
          onClick={() => {
            setShowState(undefined);
          }}
        />
      </ContainerState>
    </ModalStyled>
  );

  const treeCourses = (
    <ContainerTree>
      <TitleWrapper>
        <Title>Cursos</Title>
      </TitleWrapper>
      <CoursesStyled
        data={courses}
        getIsAllowed={() => true}
        onClick={(course) => setCourseId(course.id)}
      />
    </ContainerTree>
  );

  const treeEpisodes = (
    <ContainerTree>
      <Buttons>
        {/* <Button
          tertiary={true}
          text="Checkout"
          onClick={() => setOpenCheckout(true)}
        /> */}
        <Button primary text="Publicar" loading={loading} onClick={onPublish} />
      </Buttons>
      <TitleWrapper onClick={() => setCourseId(undefined)}>
        <Back as={ArrowBack} />
        <Title>{course?.title}</Title>
      </TitleWrapper>

      <Tree
        seed={episodes}
        onChange={(state) => setState(state)}
        onItemClick={(item) => setEpisode(item)}
      />
    </ContainerTree>
  );

  const treeChapters = (
    <ContainerTree>
      <Buttons>
        <Button primary text="Publicar" loading={loading} onClick={onPublish} />
      </Buttons>
      <TitleWrapper onClick={() => setEpisode(undefined)}>
        <Back as={ArrowBack} />
        <Title>{episode?.title}</Title>
      </TitleWrapper>

      <Tree
        seed={chapters}
        onChange={(state) => setState(state)}
        onItemClick={(item) => setChapter(item)}
      />
    </ContainerTree>
  );

  const treeLessons = (
    <ContainerTree>
      <Buttons>
        <Button primary text="Publicar" loading={loading} onClick={onPublish} />
      </Buttons>
      <TitleWrapper onClick={() => setChapter(undefined)}>
        <Back as={ArrowBack} />
        <Title>{chapter?.title}</Title>
      </TitleWrapper>

      <Tree
        seed={lessons}
        onChange={(state) => setState(state)}
        onItemClick={(item) => setLesson(item)}
      />
    </ContainerTree>
  );


  // console.log(state);
  const onChangeMmeoized = useCallback((state) => setState(state), []);

  const ModalLessonSuper = (
    <ModalLesson>
      <Content>
        <SimpleBar style={{ maxHeight: "70vh" }}>
          <ContainerWrapper>
            <LessonPreviewMiddleware
              lessonType={state?.type}
              data={state}
              seed={state?.data}
            />
          </ContainerWrapper>
        </SimpleBar>
      </Content>
      <ButtonStyled
        secondary
        text="Cerrar"
        onClick={() => setShowModalLesson(undefined)}
      />
    </ModalLesson>
  );

  const onPreview = () => {
    setShowModalLesson(true);
  };

  const editLesson = (
    <ContainerTree>
      {showModalLesson && ModalLessonSuper}
      <Buttons>
        <Button tertiary text="Previsualizar" onClick={onPreview} />
        <Button primary text="Publicar" onClick={onPublish} />
      </Buttons>
      <TitleWrapper onClick={() => setLesson(undefined)}>
        <Back as={ArrowBack} />
        <Title>{lesson?.title}</Title>
      </TitleWrapper>
      <LessonMiddleware
        lessonId={lesson?.id}
        data={details?.data}
        onChange={onChangeMmeoized}
        description={details?.description}
        advice={details?.advice}
      />
    </ContainerTree>
  );

  return (
    <Container>
      {/* <CourseEdit
        isOpen={openCheckout}
        courseId={courseId}
        onClose={() => {
          setOpenCheckout(false);
        }}
      /> */}
      <ListCheckoutPages
        isOpen={openCheckout}
        onRequestClose={() => {
          setOpenCheckout(false);
        }}
      />
      {showState && ModalState}
      {type === "COURSES" && treeCourses}
      {type === "EPISODES" && treeEpisodes}
      {type === "CHAPTERS" && treeChapters}
      {type === "LESSONS" && treeLessons}
      {type === "LESSON" && editLesson}
    </Container>
  );
};

const getType = (data) => Object.keys(data || {})[0];

const ContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: #32b0ea;
  padding: 25px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  padding: 10px;
`;

const ContainerTree = styled.div`
  display: flex;
  flex-direction: column;
`;

const Buttons = styled.div`
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  & > * {
    margin: 5px;
  }
`;

const ModalLesson = styled(Modal)`
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 95%;
`;

const ButtonStyled = styled(Button)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Content = styled.div`
  width: 100%;
`;

const ModalStyled = styled(Modal)`
  max-width: 220px;
  width: 100%;
`;

const ContainerState = styled.div`
  padding: 20px;
  & > * {
    margin: 5px;
  }
`;

const ButtonState = styled(Button)`
  margin-top: 30px;
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 0px;
  margin: 10px 0px;
  cursor: pointer;
`;

const Back = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 15px;
`;

const Title = styled.div`
  font-size: 1.5em;
  font-weight: 600;
`;

const CoursesStyled = styled(Courses)`
  .courseBox {
    background-color: #caedff;
  }
`;


export default Structure;
